import React from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import { Checkbox } from '@dbk/ui-forms';
import { NavigationListItemHeader, NavigationListItemFooter } from '@dbk/ui-list';
import { Large } from '@dbk/ui-text';
import { PALETTE } from '../../../constants';

const ReportCategoryListHeader = ((props) => {
    const { totalItems, i18n: { messages } } = props;
    return (
        <View style={{ width: "100%", height: "100%", paddingTop: 4, paddingBottom: 4, marginLeft: 5 }}>
            <NavigationListItemHeader>
                <Checkbox
                    className="checkboxClass"
                    checked={props.isChecked}
                    onClick={props.handleCategoryClick}
                    label={<Large numberOfLines={2} ellipsizeMode={'tail'} className="rowHeader" style={{ color: PALETTE.primaryActive }} testID="textbox_report_reportCategoryListHeader_test">{props.categoryName}</Large>}
                    testID="checkbox_report_reportCategoryListHeader_test"
                />
            </NavigationListItemHeader>
            <View id="text_report_reportCategoryListHeader_test" secondary className="rowFooter" style={{ color: '#a7a8aa', fontSize: "14px" }}
            >{totalItems + " " + messages['app.chedelivery.reports.listitem']}</View>

        </View>
    )
});

ReportCategoryListHeader.propTypes = {
    i18n: PropTypes.shape({
        messages: PropTypes.object,
    }),
    totalItems: PropTypes.array,
};

ReportCategoryListHeader.defaultProps = {
    i18n: {},
    totalItems: []
};

export default createContainer(
    {
        $queries: {
            edelivery: {
                getUserPreferences: { $call: 'getUserPreferences' },
                showPrompt: true,
            },
            changePage: { $call: 'ui.history.push' },
            i18n: {
                messages: true,
            },
            getLastStatements: {
                $call: 'reports.getLastStatements',
            },
            markDocumentAsCheckedOrUnchecked: {
                $call: 'reports.markDocumentAsCheckedOrUnchecked'
            },
            getStatementPdf: {
                $call: 'monthly.getPdf',
            },
            dailyPdf: {
                pdf: true,
                setEmpty: { $set: 'pdf' },
            },
            resetAdvicesDates: { $call: 'advices.resetDates' },
            resetReportsDates: { $call: 'reports.resetDates' },
            portfolio: {
                netIncome: {
                    value: true,
                },
            },
        },
    },
)(ReportCategoryListHeader);
